export default __webpack_public_path__ + "static/media/ddr.705afaba.jpg";